import React from 'react';
import logo from '../../assets/logo.avif';
import "./Navbar.css";

const Navbar = () => {
  return (
    <nav>
    <div className='nav-logo'>
    <img src={logo} alt='logo' />
    </div>
    </nav>
  );
};

export default Navbar;